import styled from '@emotion/styled';
import { StampCardRow } from '@models/stamp';

import BottomRow from './BottomRow';
import StampImages from './StampImages';
import TopRow from './TopRow';

interface Props {
    stampCard: StampCardRow;
    expand: boolean;
}

function FullCard({ stampCard, expand }:Props) {
    const { shopName } = stampCard;
    return (
        <Wrapper isHide={!expand}>
            <Contents>
                <TopRow shopName={shopName} />
                <StampImages stampCard={stampCard} />
                <BottomRow/>
                <Overlay/>
            </Contents>
        </Wrapper>
    );
}

const Wrapper = styled.div<{
    isHide?: boolean;
}>`
    max-height: ${({ isHide }) => (isHide ? 0 : 600)}px;
    overflow: hidden;
    transition: max-height 300ms;
    width: 100%;
`;

const Contents = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    width: 100%;
`;

const Overlay = styled.div`
    inset: 0;
    mix-blend-mode: overlay;
    pointer-events: none;
    position: absolute;
    z-index: 2;
    background: linear-gradient(180deg, var(--color-gray7) 0%, var(--color-gray6) 100%);
`;

export default FullCard;
